import React from 'react';
import cn from 'classnames';
import { useFilingContext } from '@/finsight/application/Filings/FilingsContext';

import tabsStyles from '@dealroadshow/uikit/core/styles/tabs.scss';
import styles from '../loanLevelHeader.scss';

interface ITab {
  name: string,
  dataTest: string,
  key: boolean,
}

const TABS: ITab[] = [
  {
    name: 'All Filings',
    key: false,
    dataTest: 'allFilingsTab',
  },
  {
    name: 'New Issue Filings',
    key: true,
    dataTest: 'newIssueFilingsTab',
  },
];

const NewIssueFilingsTabs = () => {
  const { isNewFilings, handleNewFilingsChange } = useFilingContext();

  return (
    <div className={ tabsStyles.tableTabs } data-test="fillingsTabs">
      { TABS.map(({ name, key, dataTest }) => (
        <a
          key={ name }
          data-test={ dataTest }
          onClick={ () => handleNewFilingsChange(key) }
          className={ cn(tabsStyles.tab, styles.tab, {
            [tabsStyles.isTabActive]: isNewFilings === key,
          }) }
        >
          <span>{ name }</span>
        </a>
      )) }
    </div>
  );
};

export default NewIssueFilingsTabs;
